<template>
  <div
    v-if="getVideoURL(link) && link"
    class="container overflow-hidden relative w-full"
  >
    <iframe
      class="absolute inset-0 w-full h-full"
      :src="getVideoURL(link, playVideo)"
      webkitallowfullscreen
      mozallowfullscreen
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
import { isValidHttpURL } from "../utils/fileHelpers";

export default {
  name: "VimeoVideo",

  props: {
    link: String,
    playVideo: Boolean,
  },

  methods: {
    getVideoURL(url, playVideo) {
      // https://vimeo.com/542364272 <- link inputted by user
      // https://player.vimeo.com/video/542364272 <- link compatible with iframe
      // example link -> https://vimeo.com/313396400

      let vimeoMetadata =
        "?title=0&amp;byline=0&amp;portrait=0&amp;&amp;autoplay=0&amp;api=1&amp;player_id=vimeo-player-11";

      vimeoMetadata = vimeoMetadata + (!playVideo && "&background=1");

      const vimeoId = url.split("/").pop();
      let str = "https://player.vimeo.com/video/" + vimeoId;

      str = str + vimeoMetadata;

      if (isValidHttpURL(str)) {
        return str;
      }
    },
  },
};
</script>

<style scoped>
.container {
  padding-top: 56.25%;
}
</style>
